import React, { useState, useEffect } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";

const Newsletter = () => {
  const [isGetCompanyProfileData, setCompanyProfileData] = useState({});

  const getCompanyProfileDetail = async (e) => {
    try {
      const res = await ApiCalling.request(
        "POST",
        "/GetCompanyProfile",
        null,
        null,
      );
      if (res) {
        setCompanyProfileData(res);
      } else {
        console.error(res?.msg, { toastId: "CompanyProfileDetail error" });
      }
    } catch (error) {
      console.error("Error CompanyProfileDetail :", error);
    }
  };

  useEffect(() => {
    getCompanyProfileDetail();
  }, []);

  return (
    <>
      <section className="footer_get_touch_outer" id="Contact_page">
        <div className="container">
          <div className="footer_get_touch_inner grid-70-30">
            <div className="colmun-70 get_form">
              <div className="get_form_inner">
                <div className="get_form_inner_text">
                  <h3>Get In Touch</h3>
                </div>
                <form action="#">
                  <div className="grid-50-50">
                    <input type="text" placeholder="First Name" />
                    <input type="text" placeholder="Last Name" />
                    <input type="email" placeholder="Email" />
                    <input type="tel" placeholder="Phone/Skype" />
                  </div>
                  <div className="grid-full">
                    <textarea
                      placeholder="About Your Project"
                      cols="30"
                      rows="10"
                    ></textarea>
                    <div className="submit-button">
                      <input type="submit" value="Submit" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="colmun-30 get_say_form">
              <h5>Say Hi!</h5>
              <ul className="get_say_info_sec">
                <li>
                  <i className="fa fa-envelope"></i>
                  <a href="mailto:">
                    {isGetCompanyProfileData?.accountEmailId}
                  </a>
                </li>
                <li>
                  <i className="fa fa-whatsapp"></i>
                  <a href="tel:"> {isGetCompanyProfileData?.accountMobileNo}</a>
                </li>
                <li>
                  <i className="fa fa-home"></i>
                  <a href="#">{isGetCompanyProfileData?.address}</a>
                </li>
              </ul>
              <ul className="get_say_social-icn">
                <li>
                  <a href="#">
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Newsletter;
